function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import { DIALOG_PROP_TYPES, DIALOG_MESSAGE_PROPTYPE } from '../dialog/constants';
import { MODAL_PROP_TYPES, MODAL_CHILDREN_PROPTYPE } from '../modal/constants';
import { NOTIFICATION_OPTIONS_PROP_TYPES } from '../notification/constants';
export var NOTIFICATION_POSITION_TOP = 'top';
export var NOTIFICATION_POSITION_TOAST = 'toast';
export var NOTIFICATION_POSITIONS = [NOTIFICATION_POSITION_TOP, NOTIFICATION_POSITION_TOAST];
export var OVERLAY_OPTIONS_PROP_TYPES = PropTypes.shape(_objectSpread({}, MODAL_PROP_TYPES, DIALOG_PROP_TYPES, {
  kind: PropTypes.oneOf(['dialog', 'modal']),
  children: MODAL_CHILDREN_PROPTYPE,
  message: DIALOG_MESSAGE_PROPTYPE
}));
export var BOTTOM_BAR_OPTIONS_PROP_TYPE = PropTypes.shape({
  /**
   * The content to include in the bottom bar
   */
  barContent: PropTypes.node,

  /**
   * Whether or not the bottom bar is shown
   */
  isShown: PropTypes.bool
});
export var FOCUS_DRAWER_OPTIONS_PROP_TYPES = PropTypes.shape({
  /**
   * The content for the focus drawer
   */
  content: PropTypes.node.isRequired,

  /**
   * The title for the focus drawer
   */
  title: PropTypes.node,

  /**
   * Whether or not to hide the button that will close the focus drawer
   */
  hideClose: PropTypes.bool,

  /**
   * Function to be invoked when the focus drawer is closed.
   */
  onClose: PropTypes.func,

  /**
   * Whether or not the focus drawer should be shown
   */
  isShown: PropTypes.bool,

  /**
   * Configuration options for the bottom bar w/in the focus drawer
   */
  bottomBarOptions: BOTTOM_BAR_OPTIONS_PROP_TYPE,

  /**
   * Configuration options for the notification w/in the focus drawer
   */
  notificationOptions: NOTIFICATION_OPTIONS_PROP_TYPES,

  /**
   * Callback triggered if the user clicks outside of the focus drawer
   */
  onClickOutside: PropTypes.func
});
export var STRUCTURE_MAIN_CONTAINER_CLASSNAME = 'eds-structure__main-container';